export default{
    profiler: 'Anleitung zum Profiler'
}